import { PageDefaultSegment } from "@sis/react-library";
import { PageContainer } from "../../../shared/PageContainer"
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';

export const OtherSamplesThemePage = () => {
    return (
        <PageContainer heading='Other Samples - Theme' icon={<MiscellaneousServicesIcon />}>
            <PageDefaultSegment>
                The library also contains mui themes. <br />
                This project users the mui theme from the libary.<br />
                The theme is called:
                <ul><li><b>SISDefaultTheme</b></li></ul>
                <br />
                Any other themes that may be used in several projects should also be defined in the library under a different name.<br />
                <br />
                To see where it is referenced, look at file<br />
                <i>/src/components/shared/ProjectProviders.tsx</i>
            </PageDefaultSegment>
        </PageContainer>
    )
}
